import React from 'react'
import { DataTable, TableHeader, Cell } from 'react-mdl'
import './style.css'

const shortClassMapper = {
    "Amazon": "Ama",
    "Sorceress": "Sor",
    "Necromancer": "Nec",
    "Paladin": "Pal",
    "Barbarian": "Bar",
    "Druid": "Dru",
    "Assassin": "Asn"
};

export default class CharacterTable extends React.Component {

    renderNameLink(name) {
        return (
            <a className="armory-table-link" title={`Checkout ${name} at the armory.`} target="_blank" href={`https://armory.slashdiablo.net/character/${name.toLowerCase()}`}>{name}</a>
        );
    }

    render() {
        return (
            <Cell col={12}>
            <DataTable
                className="character-table"
                shadow={0}
                rows={this.props.characters}
            >
            <TableHeader name="rank" cellFormatter={(rank) => `#${rank}`} tooltip="Current rank">Rank</TableHeader>
            <TableHeader numeric name="level" tooltip="Character level">Level</TableHeader>
            <TableHeader numeric name="name" cellFormatter={this.renderNameLink} tooltip="Character name">Name</TableHeader>
            <TableHeader numeric name="prefix" tooltip="Character title">Title</TableHeader>
            <TableHeader numeric name="class" cellFormatter={(c) => `${shortClassMapper[c]}`}  tooltip="Character class">Class</TableHeader>
            <TableHeader numeric name="status" tooltip="Character status">Status</TableHeader>
        </DataTable>
        </Cell>
        );
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/character-table/index.jsx
 **/